<template>
    <div>
        <h2>จัดการซัพพลายเออร์</h2>

        <v-card class="mt-4 px-6 pt-6">
            <v-text-field
              outlined
              v-model="datatable.search"
              placeholder="ค้นหา ..."
              dense
            ></v-text-field>
        </v-card>

        <v-card class="mt-4">
          <div class="d-flex pa-4">
            <v-btn
              @click="deleteMultiple()"
              :disabled="datatable.selectedItems.length == 0"
              v-if="$store.getters['auth/GET_ABILITY'].can('delete', 'Product')"
            ><v-icon>{{ mdiDeleteOutline }}</v-icon></v-btn>
            <v-btn
            color="primary"
            class="ml-auto"
            @click="$router.push({ 'name': 'supplier_create', params: { supplier_id: 'create' } })"
            v-if="$store.getters['auth/GET_ABILITY'].can('update', 'Product')"
            >เพิ่มซัพพลายเออร์</v-btn>
          </div>
          <delay-datatable
            show-select
            :headers="datatable.headers"
            :url="'/product/supplier/list'"
            :queryParams="getDatatableQueryParams"
            :options.sync="datatable.options"
            :isSaveState="true"
            @loadState="loadDatatableState"
            v-model="datatable.selectedItems"
            ref="mainDatatable"
          >

          <template v-slot:[`header.data-table-select`]="{ props, on }">
            <v-simple-checkbox
              :value="props.value || props.indeterminate"
              v-on="on"
              :indeterminate="props.indeterminate"
              color="primary"
              :ripple="false"
            />
          </template>

          <template
            v-slot:item.brands="{ item }"
          >
            <v-chip-group>
              <v-chip
                v-for="brand in item.brands"
                :key="item.id + '_' + brand.id"
              >
                {{ brand.name }}
              </v-chip>
            </v-chip-group>
          </template>

          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-simple-checkbox
              v-model="isSelected"
              color="primary"
              @input="select"
              :ripple="false"
            />
          </template>

          <template
            v-slot:item.actions="{ item }"
          >
            <v-btn
              icon
              @click="$router.push({name: 'supplier_create', params: { supplier_id: item.id }})"
            ><v-icon>{{ $store.getters['auth/GET_ABILITY'].can('update', 'Product') ? mdiPlaylistEdit : mdiEyeOutline }}</v-icon></v-btn>
            <v-btn
              icon
              @click="deleteSingle(item.id, item.name)"
              :disabled="!$store.getters['auth/GET_ABILITY'].can('delete', 'Product') || item.brands_count > 0"
            ><v-icon>{{ mdiDeleteOutline }}</v-icon></v-btn>
          </template>
          </delay-datatable>
        </v-card>
    </div>
</template>
<script>
import { asyncDelete } from '@/helpers/asyncAxios'
import { mdiDeleteOutline, mdiEyeOutline, mdiPlaylistEdit } from '@mdi/js'
export default {
  data() {
    return {
      datatable: {
        options: {
          page: 1,
          itemsPerPage: 10,
        },
        selectedItems: [],
        search: null,
        headers: [
          {
            text: 'ชื่อซัพพลายเออร์',
            value: 'name',
          },
          {
            text: 'จำนวนแบรนด์',
            value: 'brands_count',
          },
          {
            text: 'แบรนด์',
            value: 'brands',
            sortable: false,
          },
          {
            text: '#',
            value: 'actions',
            sortable: false,
            align: 'center',
          },
        ],
      },
      mdiDeleteOutline,
      mdiPlaylistEdit,
      mdiEyeOutline,
    }
  },
  computed: {
    getDatatableQueryParams() {
      return {
        search: this.datatable.search,
      }
    },
  },
  methods: {
    loadDatatableState({ options, queryParams }) {
      this.datatable = { ...this.datatable, options: { ...options }, ...queryParams }
    },
    isArray(data) {
      return Array.isArray(data)
    },
    async deleteMultiple() {
      const supplierNames = this.datatable.selectedItems.map(item => item.name).join(', ')
      const supplierIds = this.datatable.selectedItems.map(item => item.id)

      const dialogResult = await this.$store.dispatch('app/CONFIRM_DIALOG', {
        title: 'ยืนยันที่จะลบ ?',
        body: 'คุณต้องการที่จะลบ "' + supplierNames + '" หรือไม่ ? หากยืนยันไปแล้วจะไม่สามารถกู้ข้อมูลกลับคืนมาได้อีก',
      })

      if (!dialogResult) return

      try {
        const result = await asyncDelete('/product/supplier', { items: supplierIds })
        this.$refs.mainDatatable.reload()
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', error)
      }
    },
    async deleteSingle(id, name) {
      const dialogResult = await this.$store.dispatch('app/CONFIRM_DIALOG', {
        title: 'ยืนยันที่จะลบ ?',
        body: 'คุณต้องการที่จะลบ "' + name + '" หรือไม่ ? หากยืนยันไปแล้วจะไม่สามารถกู้ข้อมูลกลับคืนมาได้อีก',
      })

      if (!dialogResult) return

      try {
        const result = await asyncDelete('/product/supplier', { items: [id] })
        this.$refs.mainDatatable.reload()
      } catch (error) {
        this.$root.showCommonDialog('มีปัญหา', error)
      }
    },
  },
}
</script>
